const interests = [
  'JavasScript',
  'Excel',
  'C#',
  'Ruby',
  'Python',
  'Google Maps API',
  'React Native',
  'React JS',
  'Blazor',
];

export default interests;
